// extracted by mini-css-extract-plugin
module.exports = {"fresh":"Tomato_fresh__2s5Ye","stale":"Tomato_stale__3bjHh","bl":"Tomato_bl__2-LRw","br":"Tomato_br__2_ZQQ"};